<div #mapContainer class="competitor-market-map" [style.height]="height"></div>
